import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Icons from 'components/icons';
import Box from '@material-ui/core/Box';
import Slider from '@material-ui/core/Slider';
import useStyles from './brightness-panel.styles';

const BrightnessPanel = memo(({ brightness, setBrightness }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleBrightnessChange = useCallback(
    (_, value) => {
      setBrightness(`${value}`);
    },
    [setBrightness],
  );

  return (
    <>
      <Box className={classes.brightnessContainer}>
        <Icons.ReaderBrightnessLow className={classes.icon} role="img" aria-label={t('reader_icon_light_low')} title={t('reader_icon_light_low')} />
        <Slider
          min={20}
          max={100}
          color="primary"
          value={parseInt(brightness, 10)}
          onChange={handleBrightnessChange}
          aria-label="Brightness"
          title="Brightness"
          className={classes.brightnessSlider}
          classes={{
            rail: classes.brightnessSliderRail,
            thumb: classes.brightnessSliderIndicator,
          }}
        />
        <Icons.ReaderBrightnessHigh className={classes.icon} role="img" aria-label={t('reader_icon_light_high')} title={t('reader_icon_light_high')} />
      </Box>
    </>
  );
});

BrightnessPanel.propTypes = {
  brightness: PropTypes.string.isRequired,
  setBrightness: PropTypes.func.isRequired,
};

export default BrightnessPanel;
